import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-681e2664"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = ["href"];
const _hoisted_3 = { class: "roundel__content" };
const _hoisted_4 = { class: "roundel__number" };
const _hoisted_5 = { class: "roundel__title" };
const _hoisted_6 = {
    key: 1,
    class: "row"
};
const _hoisted_7 = { class: "col-lg-6 position-relative" };
const _hoisted_8 = { class: "accordion__titles sticky-titles" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "col-lg-6" };
const _hoisted_11 = ["id"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
    key: 2,
    class: "row"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["innerHTML"];
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'sticky_accordion',
    props: {
        d: {}
    },
    setup(__props) {
        const props = __props;
        const rightSideContent = ref(1);
        const openIndex = ref(0);
        let roundelDiameter = 0;
        const roundels = ref(null);
        const roundelCount = props.d.sticky_accordion.length;
        const isDisabled = (index) => {
            // Logic to determine if the title should be disabled based on the content
            return index !== rightSideContent.value;
        };
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        const isLargeScreen = ref(window.innerWidth >= 1920);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
            isLargeScreen.value = window.innerWidth >= 1920;
        });
        function toggleAccordion(index) {
            if (openIndex.value === index) {
                openIndex.value = -1;
            }
            else {
                openIndex.value = index;
            }
        }
        function isOpen(index) {
            return openIndex.value === index;
        }
        const updateRightSideContent = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = Array.from(entry.target.parentNode.children).indexOf(entry.target);
                    rightSideContent.value = index + 1;
                }
            });
        };
        const observer = new IntersectionObserver(updateRightSideContent, {
            "rootMargin": isLargeScreen.value ? "-15% 0% -55% -22%" : "-35% 0% -40% 0%",
            "threshold": isLargeScreen.value ? 0.35 : 0.1
        });
        onMounted(() => {
            // Select all content divs
            const contentDivs = document.querySelectorAll('.content');
            // Observe each content div
            contentDivs.forEach(div => {
                observer.observe(div);
            });
            window.addEventListener('load', calculateRoundelDiameter);
            window.addEventListener('resize', calculateRoundelDiameter);
        });
        const calculateRoundelDiameter = () => {
            if (roundels.value) {
                const containerWidth = roundels.value.offsetWidth;
                roundelDiameter = (containerWidth / roundelCount) - 27;
                document.documentElement.style.setProperty('--roundel-diameter', `${roundelDiameter}px`);
            }
        };
        function processedLeadIn(leadin) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(leadin, 'text/html');
            const paragraphs = doc.getElementsByTagName('p');
            for (let i = 0; i < paragraphs.length; i++) {
                const paragraph = paragraphs[i];
                if (paragraph.querySelector('strong')) {
                    paragraph.classList.add('line-height');
                }
            }
            return doc.body.innerHTML;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "sticky_accordion",
                style: _normalizeStyle(`background: ${_ctx.d.background_colour ? _ctx.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.d.show_roundels == 'true' && !isMobile.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "roundels row",
                            ref_key: "roundels",
                            ref: roundels
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.sticky_accordion, (accordion, index) => {
                                return (_openBlock(), _createElementBlock("a", {
                                    href: '#content-' + (index + 1).toString(),
                                    class: _normalizeClass(["roundel col-md-2", { 'roundel__disabled': isDisabled(index + 1) }]),
                                    key: index
                                }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString((index + 1).toString()), 1),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(accordion.title), 1)
                                    ])
                                ], 10, _hoisted_2));
                            }), 128))
                        ], 512))
                        : _createCommentVNode("", true),
                    (!isMobile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.sticky_accordion, (accordion, index) => {
                                        return (_openBlock(), _createElementBlock("h3", {
                                            key: index,
                                            class: _normalizeClass({ 'disabled': isDisabled(index + 1), 'accordion__titles--small': _ctx.d.font_style === 'small-text' })
                                        }, [
                                            _createElementVNode("a", {
                                                class: "no-style",
                                                href: '#content-' + (index + 1).toString()
                                            }, _toDisplayString(accordion.title), 9, _hoisted_9)
                                        ], 2));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.sticky_accordion, (accordion, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: _normalizeClass(["row content content__desktop", { 'content__desktop--disabled': isDisabled(index + 1) }]),
                                        id: 'content-' + (index + 1).toString()
                                    }, [
                                        _createElementVNode("div", {
                                            innerHTML: processedLeadIn(accordion.leadin)
                                        }, null, 8, _hoisted_12)
                                    ], 10, _hoisted_11));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (isMobile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.sticky_accordion, (accordion, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "accordion",
                                    key: index
                                }, [
                                    _createElementVNode("h3", {
                                        class: _normalizeClass(["accordion__titles--mobile", { 'active': isOpen(index), 'accordion__titles--mobile__small': _ctx.d.font_style === 'small-text' }]),
                                        onClick: ($event) => (toggleAccordion(index))
                                    }, _toDisplayString(accordion.title), 11, _hoisted_14),
                                    (isOpen(index))
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "content content__mobile",
                                            innerHTML: accordion.leadin
                                        }, null, 8, _hoisted_15))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 4));
        };
    }
});
